import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useQueryClient } from 'react-query';

import { GROUP_SUBSCRIPTION_GIFT } from '@src/constants';
import {
  CreateGiftSubscriptionParams,
  GROUP_SUBSCRIPTION_KEY,
  createGiftSubscription,
} from '@utils/backend-api/groupSubscriptions';

export default function useGiftSubscriptionCreate(skipSuccessToast) {
  const queryClient = useQueryClient();

  const { mutateAsync, mutate, isLoading } = useMutation(
    (params: CreateGiftSubscriptionParams) => createGiftSubscription(params),
    {
      onSuccess: () => {
        if (!skipSuccessToast) {
          toast.success('Gift has been purchased successfully');
        }
        queryClient.invalidateQueries([GROUP_SUBSCRIPTION_KEY, GROUP_SUBSCRIPTION_GIFT]);
      },
      onError: (errors: { message: string }) => {
        toast.error(errors.message);
      },
    }
  );
  return { mutateAsync, mutate, isLoading };
}
